import React, { useEffect, useState } from "react";
import { Modal, Input, Button } from "antd";
import { svg } from "../../../../Assets/svg";
import { getCurrencySymbol } from "../../../../helpers/utils";

interface CustomExchangeRateModalProps {
  open: boolean;
  onCancel: () => void;
  onSave: (rate: number) => void;
  currency: string;
  initialRate: number | "";
  exchangeDecimal: number;
}

export const CustomExchangeRateModal: React.FC<CustomExchangeRateModalProps> = ({
  open,
  onCancel,
  onSave,
  currency,
  initialRate,
  exchangeDecimal,
}) => {
  const [customRateInput, setCustomRateInput] = useState<number | string>("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (open) {
      setCustomRateInput(initialRate);
      setError(null);
    }
  }, [open, initialRate]);

  const handleSave = () => {
    const numericRate = Number(customRateInput);
    if (numericRate <= 0) {
      setError("Exchange rate must be greater than 0");
      return;
    }

    // Check decimal places
    if (customRateInput.toString().includes(".")) {
      const decimalPart = customRateInput.toString().split(".")[1];
      if (decimalPart && decimalPart.length > exchangeDecimal) {
        setError(`Maximum ${exchangeDecimal} decimal places allowed`);
        return;
      }
    }

    setError(null);
    onSave(numericRate);
  };

  return (
    <Modal
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          Edit Exchange Rate for {currency}
        </div>
      }
      open={open}
      onCancel={onCancel}
      footer={null}
      closeIcon={svg?.closeIcon}
      className="commonModalClass"
      wrapClassName="zn-1051"
      centered
      width={`35rem`}
    >
      <div className="py-3">
        <label className="custom-label mb-2 fw-bold">
          1 GBP = ({currency})
        </label>
        <Input
          type="number"
          value={customRateInput}
          onChange={(e) => {
            setCustomRateInput(e.target.value);
            setError(null);
          }}
          className={`custom-exchange-input ${error ? "border-danger" : ""} p-1`}
          size="large"
          placeholder="Enter manual rate"
          step={Math.pow(10, -exchangeDecimal)}
          min={0}
          prefix={
            <div
              className="bg-dark text-white rounded d-flex align-items-center justify-content-center"
              style={{ width: '30px', height: '30px' }}
            >
              {getCurrencySymbol(currency)}
            </div>
          }
        />
        {error && <div className="text-danger mt-1 fs-8">{error}</div>}
      </div>
      <div className="d-flex justify-content-center gap-3 mt-4">
        <Button
          onClick={onCancel}
          className="btn btn-lg btn-outline-secondary h-auto px-5"
          type="default"
        >
          CLOSE
        </Button>
        <Button
          onClick={handleSave}
          className="btn btn-lg btn-dark h-auto px-5"
        >
          SAVE
        </Button>
      </div>
    </Modal>
  );
};
